import { Suspense, useEffect, useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import { ChakraProps } from "@chakra-ui/system/dist/types/system.types";

import {
  getRecaptcha,
  getRecaptchaKey,
} from "modules/context/api/getRecaptcha";

import { Spinner } from "components/Spinner";

import { FieldPrototype } from "./FieldPrototype";
import { ErrorBoundary } from "../ErrorBoundary";
import { useReactQuery } from "../RemoteData";

interface IProps extends ChakraProps {
  name: string;
}

const RecaptchaFieldThrowable = ({ name, ...restProps }: IProps) => {
  const { setValue, getValues, formState } = useFormContext();
  const recaptchaValue = getValues(name);
  const { data: googleRecaptchaId } = useReactQuery(getRecaptchaKey(), () =>
    getRecaptcha()
  );

  const { submitCount } = formState;

  const recaptchaRef = useRef();

  const handleChange = (token: string | null) => {
    setValue(name, token, { shouldValidate: true });
  };

  useEffect(() => {
    if (!getValues(name)) {
      // @ts-ignore
      recaptchaRef?.current?.reset();
    }
  }, [getValues, name, recaptchaValue]);

  useEffect(() => {
    // after each submit recaptcha must be reset
    // @ts-ignore
    recaptchaRef?.current?.reset();
    setValue(name, null);
  }, [name, setValue, submitCount]);

  if (!googleRecaptchaId) {
    return <>Brak klucza recaptchy</>;
  }

  return (
    <FieldPrototype name={name} {...restProps}>
      {() => (
        <Controller
          name={name}
          render={() => (
            <ReCAPTCHA
              // @ts-ignore
              ref={recaptchaRef}
              // sitekey={"6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"}
              sitekey={googleRecaptchaId}
              onChange={handleChange}
            />
          )}
        />
      )}
    </FieldPrototype>
  );
};

const RecaptchaField = ({ ...props }: IProps) => {
  return (
    <Suspense fallback={<Spinner size="lg" mt={2} />}>
      <ErrorBoundary>
        <RecaptchaFieldThrowable {...props} />
      </ErrorBoundary>
    </Suspense>
  );
};

export { RecaptchaField };
